// funções do componente de paginação em
$(document).on('click', '.div-arrow.paginas.enabled', function() {
    let id = $(this).data('id');
    let container = $(`#paginas-${id}`);

    if (container.find('.item-pagina').length < 6) return;

    let larguraItem = container.find('.item-pagina').outerWidth(true);
    let scroll = container.data('scroll');
    let scrollTotal = (container.find('.item-pagina').length * larguraItem) - container.width();

    if ($(this).hasClass('div-arrow-right')) {
        if (scroll >= (scrollTotal - larguraItem)) {
            scroll = scrollTotal;
            $(`.div-arrow-right[data-id="${id}"]`).removeClass('enabled');
        } else {
            $(`.div-arrow-right[data-id="${id}"]`).addClass('enabled');
            scroll += larguraItem;
        }
        $(`.div-arrow-left[data-id="${id}"]`).addClass('enabled');
    } else {
        if (scroll <= larguraItem) {
            scroll = 0;
            $(`.div-arrow-left[data-id="${id}"]`).removeClass('enabled');
        } else {
            $(`.div-arrow-left[data-id="${id}"]`).addClass('enabled');
            scroll -= larguraItem;
        }
        $(`.div-arrow-right[data-id="${id}"]`).addClass('enabled');
    }

    container.data('scroll', scroll);
    container.scrollLeft(scroll);
});

window.atualizarComponentePaginacao = (id, page = 1) => {
    event.preventDefault();
    event.stopPropagation();
    var container = $(`#paginas-${id}`);
    let itens = container.find('.item-pagina').length;
    let scroll = container.data('scroll');

    if(itens > 5 && page > 5) {
        let larguraItem = container.find('.item-pagina').outerWidth(true);
        scroll = (page * larguraItem) - container.width();
        let scrollTotal = (itens * larguraItem) - container.width();
        if (scroll >= scrollTotal) {
            scroll = scrollTotal;
            $(`.div-arrow-right[data-id="${id}"]`).removeClass('enabled');
        } else {
            $(`.div-arrow-right[data-id="${id}"]`).addClass('enabled');
        }
        if (scroll >= larguraItem) {
            $(`.div-arrow-left[data-id="${id}"]`).addClass('enabled');
        } else {
            scroll = 0;
            $(`.div-arrow-left[data-id="${id}"]`).removeClass('enabled');
        }
    } else if (itens > 5 && page <= 5) {
        scroll = 0;
        $(`.div-arrow-left[data-id="${id}"]`).removeClass('enabled');
        $(`.div-arrow-right[data-id="${id}"]`).addClass('enabled');
    }

    container.data('scroll', scroll);
    container.scrollLeft(scroll);
}
